import styled, { css } from "styled-components";
const ChatBubble = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.background.secondaryNav};
    color: ${theme.colors.text.primary};
    margin-left: auto;
    min-width: 75%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};
    padding: ${theme.spacings.sm};
  `
);
export default ChatBubble;
